import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { PromocodeForm } from '../../pages/InternalPage/FinancesPage/components/PromocodeForm'
import { useProfileStore } from '../../store/storeProfile'

export const PromoDialog = ({ open, handleClose }) => {
    const { t } = useTranslation()
    const { isApplyPromocode, fetchBillingListAdded, setBillingTab, fetchUserTariff } =
        useProfileStore((state) => state)

    useEffect(() => {
        if (isApplyPromocode) {
            fetchUserTariff()
            setBillingTab('add')
            fetchBillingListAdded({
                limit: 25,
                offset: 0,
            })
        }
    }, [isApplyPromocode])

    return (
        <ModalDialogWrapper
            open={open}
            handleClose={handleClose}
            submitButtonText={t('promoDialog.replenishBalance')}
            colorSubmitButton="primary"
            title={
                isApplyPromocode ? (
                    <Typography variant="h4">{t('promoDialog.successTitle')}</Typography>
                ) : (
                    <>
                        <Typography variant="h4">{t('promoDialog.title')}</Typography>
                    </>
                )
            }>
            {isApplyPromocode ? (
                <Button onClick={handleClose} fullWidth type="submit" variant="contained">
                    {t('promoDialog.tryIt')}
                </Button>
            ) : (
                <PromocodeForm isDialog={true} handleClose={handleClose} />
            )}
        </ModalDialogWrapper>
    )
}
